import { render } from "./Car.vue?vue&type=template&id=0402978b&scoped=true"
import script from "./Car.vue?vue&type=script&lang=js"
export * from "./Car.vue?vue&type=script&lang=js"

import "./Car.vue?vue&type=style&index=0&id=0402978b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0402978b"]])

export default __exports__